import axios from "axios"
import { getToken } from "./firebase"
/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken
 */
export async function callMsGraph(endpoint, method, data) {
  const {
    data: {
      data: { accessToken }
    }
  } = await getToken()

  const Authorization = `Bearer ${accessToken}`

  return axios({
    url: endpoint,
    headers: { Authorization },
    method,
    data
  }).then((response) => response.data)
}
